export default __webpack_public_path__ + "static/media/logo_white_background.932aa102.png";